/**
 * Converts a hexcode, either 3 or 6 characters, to a css hex code prefixed
 * with a '#'.  Ensures that a '#' doesn't get added twice.
 */
export const stringToHexCode = (str: string | undefined): string | undefined => {
  if (!str) return undefined;

  if (str.startsWith('#')) return str;

  return `#${str}`;
};
